import React from 'react'
import { Contained } from '../../components/contained/contained'
import { SecondaryPageBanner } from '../../fragments/secondaryPageBanner'
import { Breadcrumb, Breadcrumbs } from '../../components/breadcrumbs/Breadcrumbs'
import styled from 'styled-components'
import { Button } from '../../components/button/button'
import { rem } from '../../utils'
import { html } from '../../utils/htmlParser'
import { StyledFcpAngleLine } from '../../components/flexibleContent/flexibleContentWrapper'
import { isNotNull } from '../../utils/nonNull'
import { FaqDetailPageQuery } from '@gql'

export const StyledGreyBackground = styled.div`
  z-index: 1;
  position: relative;
  padding: ${props => rem(80, props.theme)} 0;

  ${props => props.theme.breakpoints.up('sm')} {
    padding: ${props => rem(120, props.theme)} 0;
  }
`

const StyledFaqContent = styled.div`
  p {
    font-size: ${props => props.theme.typography.pxToRem(15)};
    line-height: ${props => props.theme.typography.pxToRem(28)};

    ${props => props.theme.breakpoints.up('md')} {
      font-size: ${props => props.theme.typography.pxToRem(17)};
      line-height: ${props => props.theme.typography.pxToRem(30)};
    }
  }
`

const StyledFaqTitle = styled.h2`
  font-size: ${props => props.theme.typography.pxToRem(23)};
  line-height: ${props => props.theme.typography.pxToRem(34)};
  font-weight: 500;

  ${props => props.theme.breakpoints.up('md')} {
    font-size: ${props => props.theme.typography.pxToRem(32)};
    line-height: ${props => props.theme.typography.pxToRem(45)};
  }
`


export type FAQDetailProps = FaqDetailPageQuery

export const FAQDetail: React.VFC<FAQDetailProps> = ({ entry, globalSet }) => {
  if (!entry || entry.__typename !== 'faqs_default_Entry' || !globalSet || globalSet.__typename !== 'faqPageSingleBanner_GlobalSet') {
    return null
  }


  const { title, uri, faqText } = entry
  const { secondaryPageBanner } = globalSet
  const faqTitle = 'Frequently Asked Questions'

  return (
    <>
      {secondaryPageBanner && (
        //@ts-ignore
        <SecondaryPageBanner
          after="white"
          title={faqTitle}
          { ...secondaryPageBanner }
          breadcrumbs={(
            <Breadcrumbs>
              <Breadcrumb href={'/help-and-support/'} home text={'Help and support'} />
              <Breadcrumb href={'/help-and-support/faqs'} text={'Frequently asked questions'} />
              {isNotNull(title) && (<Breadcrumb href={`/${uri}`} text={title} />)}
            </Breadcrumbs>
          )}
        />
      )}
      <StyledFcpAngleLine id={'flexibleSlantedLine'} />
      <StyledGreyBackground>
        <Contained container>
          <StyledFaqTitle>{isNotNull(title) && title}</StyledFaqTitle>
          <StyledFaqContent>{isNotNull(faqText ) && html(faqText)}</StyledFaqContent>
          <Button primary buttonColor="black" href={'/help-and-support/faqs'}>View All FAQs</Button>
        </Contained>
      </StyledGreyBackground>
    </>
  )
}